const appsData = [
  {
    id: "rain-trade",
    name: "Rain Trade",
    category: "Prediction Markets",
    creator: "Rain Protocol",
    founded: "2026",
    updated: "June 4th 2026",

    logo: "/assets/app/raintrade-logo.svg",
    shade: "/assets/appshade.png",

    visitLink: "https://www.rain.trade/",
    twitter: "https://x.com/rain__trade",

    elevatorPitch:
      <>Rain Trade is a prediction market application powered by the Rain Protocol. As an official building partner of Rain, it serves as a primary implementation of the protocol's core features in a single, accessible environment. The platform is permissionless, allowing you to launch your own markets on any verifiable event or trade on global outcomes. Whether you want to host invitation-only private markets for a specific community or open global forecasts to the public, Rain Trade provides the interface to turn those predictions into tradable assets.</>,

    features: [
      "Permissionless Market Creation: Launch a market on any topic, from global sports and politics to niche community events.",
      "Public and Private Markets: Choose between open trading or restricted markets that require a secret access code to participate.",
      "AI-Powered Resolutions: Opt for data-driven, objective results through the protocol’s AI oracle or manage the resolution process manually.",
      "Gas-Sponsored Experience: Trade without the friction of manual gas management. The platform uses account abstraction to keep the blockchain side invisible",
      "Cross-Chain Funding: Fund your account using assets from Base, Ethereum, BNB Chain, or Arbitrum. The system handles bridging and conversion automatically so you can trade in USDC.",
      "Market Rewards: Earn a 1% fee from trading volume in any market you create, 0.3% from trading volume for closing a market or participate as a liquidity provider to earn 1.2% share of the trading volume."
    ],

    images: [
      "/assets/app/raintrade/1.png",
      "/assets/app/raintrade/2.png",
      "/assets/app/raintrade/3.png",
      "/assets/app/raintrade/4.png"
    ]
  },
  {
    id: "pred",
    name: "Pred",
    category: "Prediction Markets",
    creator: "Rain Protocol",
    founded: "2025",
    updated: "February 4th 2026",

    logo: "/assets/logorain.svg",
    shade: "/assets/appshade.png",

    visitLink: "/pred",
    twitter: "https://x.com/RainPredictions",

    elevatorPitch:
      <>Pred is the ultimate marketplace for prediction markets built on Rain Protocol. It serves as a global aggregator for every market built on the Protocol, regardless of language or topic. By centralizing all protocol-based markets in one place, Pred allows users to easily discover, track, and participate in any forecast created across the entire ecosystem.</>,

    features: [
      "Create custom prediction markets",
      "Real-time market data and analytics",
      "Automated outcome resolution",
      "Social trading features",
      "Multi-chain support"
    ],

    images: [
      "/assets/Screenshotrain.png",
      "/assets/screenshottwo.svg",
      "/assets/screenshotthree.svg",
      "/assets/screenshotfour.svg"
    ]
  },
  {
    id: "risk-market",
    name: "Risk Markets",
    category: "Risk Markets",
    creator: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
    founded: "2026",
    updated: "February 4th 2026",

    logo: "/assets/app/riskmarket-logo.png",
    shade: "/assets/app/riskshade.png",

    visitLink: "https://www.riskmarkets.fun/",
    twitter: "https://x.com/risk_markets",

    elevatorPitch:
      <>The Ultimate Test of Nerve. Forget complex charts and order books - Risk Markets distill trading down to a single, high-stakes decision: Hold or Fold. The mechanic is simple. Open a position and watch your profit multiplier climb in real-time. You have complete control over the exit and can lock in your gains whenever you choose. But there’s a catch - the market is governed by a random number generator and can terminate at any second. Hold longer for a shot at returns up to 9,900%, or exit early to secure a safer win. If the market terminates before you act, your position closes at $0. It’s you versus the algorithm—do you have the discipline to walk away, or the nerve to hold on?</>,

    features: [
      "Real-Time Execution: Watch the profit multiplier climb and decide the exact millisecond to exit.",
      "You Control the Exit: Total autonomy to lock in your gains at any point during the run.",
      "Unpredictable Rounds: Each scenario evolves independently with a random termination point, creating a unique 'hold-or-fold' experience every time.",
      "Shared Liquidity Integration: Built on Rain Protocol’s shared liquidity add-on for seamless, high-velocity action.",
      "On-Chain Verification: Every decision and termination is executed and verified on the blockchain."
    ],

    images: [
      "/assets/app/1.png",
      "/assets/app/2.png",
      "/assets/app/3.png",
      "/assets/app/4.png"
    ]
  },
  {
    id: "black-jack",
    name: "Blackjack Markets",
    category: "Social Trading",
    creator: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
    founded: "2026",
    updated: "11 March 2026",

    logo: "/assets/app/blackjack-logo.png",
    shade: "/assets/app/blackjackshade.png",

    visitLink: "https://blackjack.market/",
    twitter: "",

    elevatorPitch:
      <>Blackjack Markets lets you trade on blackjack hands as the cards hit the table. Instead of just playing against a house, you buy and sell positions based on how the hand is developing. The odds shift with every card revealed, so you can enter or exit a trade as the action unfolds. Every round settles on-chain with real payouts and no house edge. Built on Rain protocol.</>,

    features: [
      "Live Card-by-Card Trading: Buy and sell positions as each card is revealed. Odds update in real time.",
      "Timed Rounds: Fast-paced hands with a specific trading window before cards lock.",
      "Automatic On-Chain Payouts: Winnings are settled and sent by smart contracts as soon as the round ends.",
      "Live Activity Feed: Track every position and see the volume move in real time.",
      "In-Round Chat: Talk with other players while the hand is live to get a feel for the market sentiment.",
      "Simple Connection: Web3-native experience. Just connect your wallet and play.",
      "Mobile Optimized: Full support for both desktop and mobile devices."
    ],

    images: [
      "/assets/app/blackjack2.png",
      "/assets/app/blackjack1.png",
      "/assets/app/blackjack3.png",
      "/assets/app/blackjack4.png"
    ]
  }
];

export default appsData;
